import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    fetchPlans as fetchPlansApi,
    fetchMyPlan as fetchMyPlanApi,
    subscribeToPlan as subscribeToPlanApi,
} from "../../services/Plan";

export const fetchPlans = createAsyncThunk(
    "plan/fetchPlans",
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchPlansApi();
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const fetchMyPlan = createAsyncThunk(
    "plan/fetchMyPlan",
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchMyPlanApi();
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const subscribeToPlan = createAsyncThunk(
    "plan/subscribeToPlan",
    async ({ planId, billingInterval = "monthly" }, { rejectWithValue }) => {
        try {
            const response = await subscribeToPlanApi(planId, billingInterval);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const planSlice = createSlice({
    name: "plan",
    initialState: {
        plans: [],
        myPlan: null,
        usage: null,
        loading: false,
        subscribeLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPlans.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPlans.fulfilled, (state, action) => {
                state.loading = false;
                state.plans = action.payload.data || [];
            })
            .addCase(fetchPlans.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            .addCase(fetchMyPlan.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchMyPlan.fulfilled, (state, action) => {
                state.loading = false;
                state.myPlan = action.payload.data?.plan || null;
                state.usage = action.payload.data?.usage || null;
            })
            .addCase(fetchMyPlan.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            .addCase(subscribeToPlan.pending, (state) => {
                state.subscribeLoading = true;
            })
            .addCase(subscribeToPlan.fulfilled, (state, action) => {
                state.subscribeLoading = false;
            })
            .addCase(subscribeToPlan.rejected, (state, action) => {
                state.subscribeLoading = false;
                state.error = action.payload || action.error.message;
            });
    },
});

export default planSlice.reducer;
